"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
const constants_1 = require("../constants");
class ContentImportModulesStore {
    constructor() {
        this.modules = [];
        this.checkedAll = false;
        this.checkModule = (moduleId) => {
            this.modules = this.modules.map((module) => {
                if (module.id === moduleId) {
                    return {
                        ...module,
                        isChecked: !module.isChecked,
                        isIndeterminate: false,
                        pages: module.pages.map((page) => ({
                            ...page,
                            isChecked: !module.isChecked
                        }))
                    };
                }
                return module;
            });
            this.checkedAll = this.modules.every((module) => module.isChecked && !module.isIndeterminate);
        };
        this.checkModulePage = (moduleId, pageId) => {
            this.modules = this.modules.reduce((accumulator, currentModule) => {
                if (currentModule.id === moduleId) {
                    const _pages = currentModule.pages.reduce((accumulatorPages, currentPage) => {
                        if (currentPage.id === pageId) {
                            currentPage.isChecked = !currentPage.isChecked;
                        }
                        accumulatorPages.push(currentPage);
                        return accumulatorPages;
                    }, []);
                    const isAllPagesChecked = _pages.every((item) => item.isChecked);
                    const isSomePagesChecked = !isAllPagesChecked && _pages.some((item) => item.isChecked);
                    currentModule.isChecked = isAllPagesChecked;
                    currentModule.isIndeterminate = isSomePagesChecked;
                    currentModule.pages = _pages;
                }
                accumulator.push(currentModule);
                return accumulator;
            }, []);
            this.checkedAll = this.modules.every((module) => module.isChecked && !module.isIndeterminate);
        };
        this.checkAll = (isChecked) => {
            this.checkedAll = isChecked;
            this.modules = this.modules.map((module) => ({
                ...module,
                isChecked,
                isIndeterminate: false,
                pages: module.pages.map((page) => ({
                    ...page,
                    isChecked
                }))
            }));
        };
    }
    setModules(modules) {
        const _modules = this.convertToModuleList(modules);
        this.modules = _modules;
    }
    setModulePages(moduleId, pages) {
        const _modules = this.modules.reduce((accumulator, currentModule) => {
            if (currentModule.id === moduleId) {
                const _pages = this.convertToModulePageList(pages, currentModule);
                currentModule.pages = _pages;
            }
            accumulator.push(currentModule);
            return accumulator;
        }, []);
        this.modules = _modules;
    }
    clear() {
        this.modules = [];
        this.checkedAll = false;
    }
    get hasSelectedItems() {
        return this.modules.some((item) => item.isChecked || item.pages.some((pageItem) => pageItem.isChecked));
    }
    get selectedModules() {
        return this.modules.filter((module) => module.isChecked || module.isIndeterminate);
    }
    get moduleSelectionIsValid() {
        return this.selectedModules.length <= constants_1.MAX_MODULES;
    }
    get pageSelectionIsValid() {
        return !this.selectedModules.some((module) => {
            const checkedPages = module.pages.length === 0
                ? module.totalPages
                : module.pages.filter((page) => page.isChecked).length;
            return checkedPages > constants_1.MAX_PAGES_PER_MODULE;
        });
    }
    get selectionIsValid() {
        return this.moduleSelectionIsValid && this.pageSelectionIsValid;
    }
    convertToModuleList(modules) {
        return modules.map((module) => {
            const item = {
                id: module.id,
                title: module.name,
                totalPages: module.totalPages,
                extra: module.extra,
                pages: [],
                classHashIds: module.classes,
                isChecked: this.checkedAll
            };
            return item;
        });
    }
    convertToModulePageList(pages, currentModule) {
        function isPageChecked(pageId) {
            if (!currentModule.isChecked) {
                const existingPage = currentModule.pages.find((item) => item.id === pageId);
                return existingPage === null || existingPage === void 0 ? void 0 : existingPage.isChecked;
            }
            return true;
        }
        return pages.map((page) => {
            const isChecked = isPageChecked(page.id);
            const newPage = {
                id: page.id,
                title: page.name,
                isChecked,
                published: page.published,
                type: page.type
            };
            return newPage;
        });
    }
}
__decorate([
    mobx_1.observable
], ContentImportModulesStore.prototype, "modules", void 0);
__decorate([
    mobx_1.observable
], ContentImportModulesStore.prototype, "checkedAll", void 0);
__decorate([
    mobx_1.action
], ContentImportModulesStore.prototype, "setModules", null);
__decorate([
    mobx_1.action
], ContentImportModulesStore.prototype, "setModulePages", null);
__decorate([
    mobx_1.action
], ContentImportModulesStore.prototype, "checkModule", void 0);
__decorate([
    mobx_1.action
], ContentImportModulesStore.prototype, "checkModulePage", void 0);
__decorate([
    mobx_1.action
], ContentImportModulesStore.prototype, "clear", null);
__decorate([
    mobx_1.action
], ContentImportModulesStore.prototype, "checkAll", void 0);
__decorate([
    mobx_1.computed
], ContentImportModulesStore.prototype, "hasSelectedItems", null);
__decorate([
    mobx_1.computed
], ContentImportModulesStore.prototype, "selectedModules", null);
__decorate([
    mobx_1.computed
], ContentImportModulesStore.prototype, "moduleSelectionIsValid", null);
__decorate([
    mobx_1.computed
], ContentImportModulesStore.prototype, "pageSelectionIsValid", null);
__decorate([
    mobx_1.computed
], ContentImportModulesStore.prototype, "selectionIsValid", null);
exports.default = new ContentImportModulesStore();
